import React, { useEffect, useState } from "react";
import { getTeam, addTeamMember, deleteTeamMember } from "@/api";
import { TEAM_ROLES, inputCls } from "./adminShared";
import { toast } from "sonner";
import { Trash2, UserPlus } from "lucide-react";

export default function AdminTeam() {
  const [team, setTeam] = useState([]);
  const [name, setName] = useState("");
  const [role, setRole] = useState("guia");
  const [phone, setPhone] = useState("");

  useEffect(() => {
    getTeam().then(setTeam).catch(() => {});
  }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toast.error("Ingresa un nombre");
      return;
    }
    try {
      const member = await addTeamMember({ name: name.trim(), role, phone });
      setTeam((t) => [member, ...t]);
      setName("");
      setPhone("");
      toast.success("Integrante agregado");
    } catch {
      toast.error("No se pudo agregar");
    }
  };

  const remove = async (id) => {
    try {
      await deleteTeamMember(id);
      setTeam((t) => t.filter((m) => m.id !== id));
      toast.success("Integrante eliminado");
    } catch {
      toast.error("No se pudo eliminar");
    }
  };

  const roleLabel = (key) => TEAM_ROLES.find((r) => r.key === key)?.label || key;

  return (
    <div data-testid="admin-team">
      <p className="eyebrow mb-2">Operaciones</p>
      <h1 className="font-serif-hc font-light text-3xl md:text-4xl text-[#F5F2EA]">Equipo</h1>
      <p className="text-sm text-[#A3A095] mt-2">Guías, fotógrafos y transporte disponibles para asignar en cada reserva.</p>

      <form onSubmit={add} className="mt-7 grid grid-cols-1 sm:grid-cols-4 gap-3 max-w-3xl">
        <input data-testid="team-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Nombre" className={inputCls} />
        <select data-testid="team-role" value={role} onChange={(e) => setRole(e.target.value)} className={inputCls}>
          {TEAM_ROLES.map((r) => <option key={r.key} value={r.key} className="bg-[#080D0B]">{r.label}</option>)}
        </select>
        <input data-testid="team-phone" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Teléfono (opcional)" className={inputCls} />
        <button data-testid="team-add" type="submit" className="hc-btn-primary inline-flex items-center justify-center gap-2">
          <UserPlus size={14} /> Agregar
        </button>
      </form>

      <div className="mt-6 border border-[#1E2B25] divide-y divide-[#1E2B25] max-w-3xl">
        {team.map((m) => (
          <div key={m.id} data-testid={`team-row-${m.id}`} className="flex items-center justify-between gap-4 px-5 py-4">
            <div>
              <p className="text-[#F5F2EA] text-sm">{m.name}</p>
              <p className="text-xs text-[#A3A095] mt-0.5">{roleLabel(m.role)}{m.phone ? ` · ${m.phone}` : ""}</p>
            </div>
            <button data-testid={`team-delete-${m.id}`} onClick={() => remove(m.id)} className="text-[#A3A095] hover:text-red-400 transition-colors" aria-label="Eliminar">
              <Trash2 size={15} />
            </button>
          </div>
        ))}
        {!team.length && <p className="p-8 text-center text-[#A3A095] text-sm" data-testid="team-empty">Aún no hay integrantes registrados.</p>}
      </div>
    </div>
  );
}
